import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=11210e63&scoped=true"
import script from "./VersionList.vue?vue&type=script&lang=js"
export * from "./VersionList.vue?vue&type=script&lang=js"
import style0 from "./VersionList.vue?vue&type=style&index=0&id=11210e63&prod&lang=scss&scoped=true"
import style1 from "./VersionList.vue?vue&type=style&index=1&id=11210e63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11210e63",
  null
  
)

export default component.exports